<template>
  <div>
    <modal-confirmacion
      :arbitroSelected="arbitroSelected"
      :action="accionAlterna"
      @eliminado="showMensajeEliminado($event)"
      @revisado="showMensajeRevisado"
    ></modal-confirmacion>
    <add-new-arbitro
      :arbitroSelected="arbitroSelected"
      :arbitroAuxiliar="arbitroAuxiliar"
      :posiciones="listPositions"
      :categoriaSeleccionada="categoriaSeleccionada"
      :listCategorias="listCategoriasAdmin"
      @recargar="recargaUdpate($event)"
      @recargarHistorial="getArbitros($event)"
    ></add-new-arbitro>
    <upload-modal-excel
      :dataEquipo="arbitroData"
      @recargar="getArbitros($event)"
    ></upload-modal-excel>
    <b-tabs pills class="m-0" v-model="tabModel">
      <b-tab title="Mi gremio" :active="false">
        <b-card no-body>
          <div class="m-2">
            <b-row>
              <b-col
                v-if="USER().rol !== ROLES.CLUB"
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <v-select
                  placeholder="Seleccione Gremio"
                  :options="listGremios"
                  :clearable="false"
                  style="width: 100%"
                  @input="changeGremio"
                  v-model="categoriaAdmin"
                />
              </b-col>
              <b-col
                v-if="
                  USER().rol === `${ROLES.ADMIN}` ||
                    USER().rol === `${ROLES.SUPER}` ||
                    (USER().rol === `${ROLES.CLUB}` &&
                      arbitroData.id_gremio_arbitral != '')
                "
                cols="12"
                :md="USER().rol == 'club' ? 5 : 6"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <b-dropdown
                  v-if="arbitroData.id_gremio_arbitral != ''"
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <b-button
                      v-b-tooltip.hover.v-primary
                      title="Agregar Arbitros"
                      variant="flat-primary"
                      class="btn-icon"
                      size="sm"
                    >
                      <feather-icon size="22" icon="UserPlusIcon" />
                    </b-button>
                  </template>
                  <b-dropdown-item @click="createPlayer"
                    ><feather-icon icon="PlusIcon" />
                    <span class="align-middle ml-50"
                      >Individual</span
                    ></b-dropdown-item
                  >
                  <!-- <b-dropdown-item @click="openModalExcel"
                    ><feather-icon icon="PaperclipIcon" />
                    <span class="align-middle ml-50"
                      >Excel</span
                    ></b-dropdown-item
                  > -->
                </b-dropdown>
              </b-col>

              <b-col
                v-if="arbitroData.id_gremio_arbitral != ''"
                cols="12"
                md="3"
                class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
              >
                <b-form-input
                  v-model="searchQuery"
                  class="d-inline-block mr-1"
                  placeholder="Buscar..."
                />
              </b-col>
              <!-- {{ arbitroData }} -->
            </b-row>
          </div>
          <b-overlay :show="showLoading" rounded="sm">
            <div class="ml-1 mr-1">
              <b-table
                ref="refInvoiceListTable"
                :fields="tableColumns"
                :items="listPlayersFilter"
                primary-key="id"
                show-empty
                responsive
                small
                selectable
                select-mode="multi"
                empty-text="No se encontraron datos"
                class="position-relative"
                style="max-height:50vh"
                :sticky-header="true"
                :no-border-collapse="true"
              >
                <!-- Column: Id -->

                <!-- Column: Player -->
                <template #cell(arbitro)="data">
                  <b-media vertical-align="center">
                    <template #aside>
                      <div style="display:grid">
                        <b-avatar
                          size="32"
                          :src="data.item.foto_jug"
                          :text="avatarText(data.item.nombre)"
                        />
                        <!-- <small v-if="data.item.nuevo == 's'" class="new"
                        >New</small
                      > -->
                      </div>
                    </template>
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.nombre }}
                    </span>
                    <small class="text-muted">{{
                      data.item.ci_pasaporte
                    }}</small>
                  </b-media>
                </template>

                <template #cell(fecha_nac)="data">
                  <b-media vertical-align="center">
                    <span class="font-weight-bold d-block text-nowrap">
                      {{ data.item.fecha_nac }}
                    </span>
                    <small class="text-muted">{{ data.item.edad }}</small>
                  </b-media>
                </template>

                <!-- <template #cell(estado_jug)="data">
                <template>
                  <b-badge
                    pill
                    :variant="
                      data.item.estado_jug === `${ESTADO_JUGADOR.INSCRITO}`
                        ? 'light-secondary'
                        : data.item.estado_jug === `${ESTADO_JUGADOR.REVISADO}`
                        ? 'warning'
                        : 'success'
                    "
                  >
                    {{ data.item.estado_jug }}
                  </b-badge>
                </template>
              </template> -->
                <!-- Column: Actions -->
                <template #cell(acciones)="data">
                  <div class="text-nowrap">
                    <feather-icon
                      :id="`invoice-row-${data.item.id}-send-icon`"
                      icon="EditIcon"
                      class="cursor-pointer"
                      size="16"
                      @click="getDataPlayer(data.item)"
                    />
                    <feather-icon
                      v-if="
                        (USER().rol === ROLES.CLUB &&
                          arbitroData.isOpen &&
                          !categoriaSeleccionada.isInReview &&
                          data.item.isCalificado !== 's') ||
                          USER().rol === ROLES.SUPER ||
                          USER().rol === ROLES.ADMIN ||
                          USER().rol === ROLES.CALIFICACION
                      "
                      :id="`invoice-row-${data.item.id}-preview-icon`"
                      icon="Trash2Icon"
                      size="16"
                      class="mx-1"
                      @click="showModalConfirmacion(data.item, 'delete')"
                    />
                  </div>
                </template>
              </b-table>
            </div>
          </b-overlay>
          <b-row v-if="listPlayersFilter.length != 0" class="ml-1 mb-1">
            <b-col md="2">
              <b-badge variant="secondary">
                <feather-icon icon="UserIcon" class="mr-25" />
                <span>Total : {{ totalInscritos }}</span>
              </b-badge>
            </b-col>

            <!-- <b-col md="4" style="text-align:right; ">
              <vue-excel-xlsx
                :data="listPlayersFilter"
                :columns="columns"
                :file-name="'listado'"
                :file-type="'xlsx'"
                :sheet-name="'sheetname'"
                class="excel"
              >
                Exportar Excel
              </vue-excel-xlsx>
            </b-col> -->
          </b-row>
          <!-- <div ref="refP">
        This is a root element
      </div> -->
        </b-card>
      </b-tab>
      <b-tab
        title="Estadisticas"
        @click="tabPasesActive"
        v-if="
          USER().rol === `${ROLES.ADMIN}` ||
            USER().rol === `${ROLES.SUPER}` ||
            USER().rol === `${ROLES.CALIFICACION}`
        "
      >
        <b-card no-body>
          <div class="mt-2">
            <b-overlay :show="false" rounded="sm"> </b-overlay>
          </div>
        </b-card>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import vSelect from 'vue-select'
import {
  BButton,
  BCard,
  VBTooltip,
  BRow,
  BCol,
  BFormInput,
  BTable,
  BMedia,
  BAvatar,
  // BTooltip,
  BBadge,
  BOverlay,
  BDropdown,
  BDropdownItem,
  BTabs,
  BTab,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { avatarText } from '@core/utils/filter'
import {
  ref,
  onMounted,
  watch,
  // watchEffect,
  // reactive,
  computed,
  onUnmounted,
  // onBeforeMount,
  //  ccc
} from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import useInscription from './useArbitros'
import AddNewArbitro from './AddArbitro.vue'
import uploadModalExcel from './UploadExcel.vue'
import {
  // URL,
  USER,
  ROLES,
  ESTADO_JUGADOR,
  // INSERT_DATA_PLAYER,
  // INSERT_DATA_HISTORY_PLAYER,
  // UPDATE_DATA_PLAYER,
} from '../../utils/variables'
import ModalConfirmacion from './ModalConfirmacion.vue'

// eslint-disable-next-line
// const Draggabilly = require('draggabilly')

export default {
  components: {
    BCard,
    vSelect,
    BButton,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BMedia,
    BAvatar,
    // BTooltip,
    BBadge,
    AddNewArbitro,
    uploadModalExcel,
    BOverlay,
    BDropdown,
    BDropdownItem,
    ModalConfirmacion,
    BTabs,
    BTab,

    // AddEx,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    // const listJugadores = ref([])
    // const refP = ref(null)
    const arbitroSelected = ref({})
    const arbitroAuxiliar = ref({})
    const accionAlterna = ref('')
    const tabModel = ref(0)
    const columns = ref([
      {
        label: 'Nombre',
        field: 'nombre',
      },
      {
        label: 'Club',
        field: 'equipo',
        // dataFormat: this.priceFormat,
      },
      // {
      //   label: 'Quantity',
      //   field: 'quantity',
      // },
      // {
      //   label: 'Country',
      //   field: 'address.country',
      // },
      // {
      //   label: 'City',
      //   field: 'address.city',
      // },
    ])
    const dataEx = ref([
      {
        product: 'Beverage',
        price: 10,
        quantity: 2,
        address: {
          country: 'Armenia',
          city: 'Yerevan',
        },
      },
      {
        product: 'Snack',
        price: 12,
        quantity: 6,
        address: {
          country: 'Armenia',
          city: 'Yerevan',
        },
      },
      {
        product: 'Beverage',
        price: 10,
        quantity: 5,
        address: {
          country: 'Armenia',
          city: 'Yerevan',
        },
      },
      {
        product: 'Snack',
        price: 12,
        quantity: 3,
        address: {
          country: 'Armenia',
          city: 'Yerevan',
        },
      },
    ])

    // const draggieFoto = new Draggabilly('.dragDiv')
    // draggieFoto.on('dragMove', function() {
    //   console.log('dragMove')
    // })

    const {
      tableColumns,
      listGremios,
      listJugadores,
      getCategoriasEditar,
      getlistGremios,
      changeGremio,
      getArbitros,
      searchQuery,
      refInvoiceListTable,
      listPlayersFilter,
      arbitroData,
      getPositionsDiscipline,
      listPositions,
      listCategoriasAdmin,
      INSERT_DATA_PLAYER,
      UPDATE_DATA_PLAYER,
      categoriaAdmin,
      uploadExcel,
      showLoading,
      // updateSolicitudRevision,
      categoriaSeleccionada,
      getTotal,
      totalInscritos,
      gremioSeleccionada,
      // arbitroSelected,
    } = useInscription()
    function showModalConfirmacion(item, action) {
      item.id_gremio_arbitral = gremioSeleccionada.value.value
      arbitroSelected.value = item
      accionAlterna.value = action
      store.commit('someVariables/UPDATE_SHOW_CONFIRMACION_ARBITRO', true)
    }
    function showMensajeEliminado(item) {
      getArbitros(item.id_gremio_arbitral)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ELIMINADO con éxito',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'top-center',
          // eslint-disable-next-line
        }
      )
    }
    function showMensajeRevisado() {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'REVISION EXITOSA',
            icon: 'AlertCircleIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        }
      )
    }

    function getDataPlayer(item) {
      item.id_gremio_arbitral = gremioSeleccionada.value.value
      arbitroSelected.value = { ...item }
      arbitroAuxiliar.value = { ...item }
      // console.log(arbitroSelected)
      // console.log(arbitroSelected.value)
      store.commit('someVariables/UPDATE_ACTION_ARBITRO', UPDATE_DATA_PLAYER)
      store.commit('someVariables/UPDATE_SHOW_NEW_ARBITRO', true)
    }

    function recargaUdpate(idEquipo) {
      getArbitros(idEquipo)
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'ARBITRO actualizado exitosamente',
            icon: 'CheckIcon',
            variant: 'success',
            solid: true,
          },
        },
        {
          position: 'bottom-center',
          // eslint-disable-next-line
        }
      )
    }

    onUnmounted(() => {
      // console.log('abandono')
      store.commit('someVariables/UPDATE_ACTIVATE_EQUIPO_REVISION', {})
    })
    // const showNewPlayer = AddNewPlayer

    // function imprimirCarnets() {
    //   console.log(listPlayersFilter.value)
    // }
    function openModalExcel() {
      store.commit('someVariables/UPDATE_SHOW_UPLOAD_EXCEL', true)
    }
    function openInputFile(elemId) {
      const elem = document.getElementById(elemId)
      if (elem && document.createEvent) {
        const evt = document.createEvent('MouseEvents')
        evt.initEvent('click', true, false)
        elem.dispatchEvent(evt)
      }
    }
    function changeExcel(item) {
      // const a = document.getElementById('file').value.split('\\')
      // console.log(a[a.length - 1])
      // console.log(item.target.files)
      uploadExcel(item.target.files[0])
    }

    function createPlayer() {
      store.commit('someVariables/UPDATE_SHOW_NEW_ARBITRO', true)
      store.commit('someVariables/UPDATE_ACTION_ARBITRO', INSERT_DATA_PLAYER)
      arbitroSelected.value = { ...arbitroData }
      // console.log(arbitroSelected)
      // console.log(arbitroData)
    }
    function cargaCategoriasTypeUser(rol) {
      // console.log(rol)
      if (rol === ROLES.CLUB) {
        getCategoriasEditar()
      } else {
        getlistGremios()
        // eslint-disable-next-line
        // store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      }
    }
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado']
    )
    watch(cambioTorneo, () => {
      // listEquipos.value = []
      categoriaSeleccionada.value = {
        label: 'Seleccione Equipo',
        isInReview: false,
      }
      listJugadores.value = []
      arbitroData.id_gremio_arbitral = ''
      categoriaAdmin.value = null
      cargaCategoriasTypeUser(USER().rol)
    })
    // onBeforeMount(() => {
    //   console.log('unbeforeee')
    //   this.$router.push('/')
    // })
    onMounted(() => {
      // console.log(USER())
      cargaCategoriasTypeUser(USER().rol)
      // console.log(refP.value)
    })
    function tabPasesActive() {
      // console.log('jugapasee')
    }

    return {
      tableColumns,
      listGremios,
      listJugadores,
      getCategoriasEditar,
      changeGremio,
      getArbitros,
      avatarText,
      searchQuery,
      refInvoiceListTable,
      listPlayersFilter,
      // refP,
      createPlayer,
      arbitroSelected,
      getPositionsDiscipline,
      listPositions,
      getDataPlayer,
      INSERT_DATA_PLAYER,
      UPDATE_DATA_PLAYER,
      listCategoriasAdmin,
      categoriaAdmin,
      USER,
      ROLES,
      ESTADO_JUGADOR,
      openInputFile,
      changeExcel,
      openModalExcel,
      arbitroData,
      showLoading,
      // updateSolicitudRevision,
      categoriaSeleccionada,
      showModalConfirmacion,
      showMensajeEliminado,
      recargaUdpate,
      accionAlterna,
      getTotal,
      totalInscritos,
      tabModel,
      tabPasesActive,
      showMensajeRevisado,
      columns,
      dataEx,
      arbitroAuxiliar,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
// .b-table-sticky-header {
//     overflow-y: auto;
//     max-height: 60vh;
// }
.new {
  font-size: 9px;
  text-align: center;
  background-color: rgb(230, 36, 10);
  color: white;
  margin-top: 2px;
  border-radius: 10px;
}
.excel {
  color: #ede5e5;
  background-color: #243e3e;
  border: 4px;
  border-radius: 4px;
  font-size: 11px;
  padding: 2px 4px 2px 5px;
  margin-right: 12px;
  font-weight: bold;
}
</style>
